import { useLayoutEffect } from "react";
import { DOMAIN_MAP, DESKTOP_BREAKPOINT } from "@/_utils/contstans";

export const useDesktopRedirect = (): void => {
  useLayoutEffect((): void => {
    const redirectKey = `desktop-redirect-${window.location.hostname}`;
    const alreadyRedirected = sessionStorage.getItem(redirectKey);

    if (alreadyRedirected) {
      return;
    }

    const isDesktop: boolean = window.innerWidth >= DESKTOP_BREAKPOINT;
    const currentHost: string = window.location.hostname;
    const targetUrl: string | undefined = DOMAIN_MAP[currentHost];
    const isAlreadyOnMobile: boolean = currentHost.startsWith("m.") || currentHost.startsWith("dev.m.");

    if (isDesktop && targetUrl && isAlreadyOnMobile && new URL(targetUrl).origin !== window.location.origin) {
      sessionStorage.setItem(redirectKey, 'true');
      window.location.replace(targetUrl);
    }
  }, []);
};
